import Menu from './Menu'
import SidebarMobile from './Mobile'
import Head from './Head'
import SidebarReleaseNote from './SidebarReleaseNote'
import { useAppStore } from '@/stores/useAppStore'

const Sidebar = () => {
    const { sideBarFull } = useAppStore((state) => state)
    return (
        <>
            <div
                className={`md:flex hidden flex-col ${sideBarFull ? 'p-4 w-[241px]' : 'w-[58px]'} md:relative fixed md:h-svh bg-white z-10 h-auto left-0 bottom-0 border-r border-gray-100`}
            >
                <Head sideBarFull={sideBarFull} />
                <div className="full h-[1px] bg-blue-primary mt-4 mx-auto" />
                <div className="flex-1 overflow-y-auto no-scrollbar">
                    <div className="flex md:flex-col flex-row">
                        <Menu hiddenText={sideBarFull} />
                    </div>
                </div>
                {/* Release Notes at bottom */}
                <div
                    className={`border-t border-gray-100 ${sideBarFull ? 'p-2' : 'p-1'}`}
                >
                    <SidebarReleaseNote expanded={sideBarFull} />
                </div>
            </div>
            <SidebarMobile />
        </>
    )
}

export default Sidebar
